module.exports = __webpack_public_path__ + "static/media/logo.febe5755.png";